import React from 'react';
import { TitleProps } from './types';

const Title: React.FC<TitleProps> = ({title, className, variant, textAlign = 'start'}) => {
	const Component = variant;
  return <Component className={className ?? ''} style={{textAlign}} >{title}</Component>;
}

export default Title;
